// extracted by mini-css-extract-plugin
export default {"root":"MainPageContent_root__mXqS7"};